import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { interval } from 'rxjs/internal/observable/interval';
import { Subscription } from 'rxjs/internal/Subscription';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { MonedoService } from 'src/app/core/services/monedo.service';

@Component({
  selector: 'app-kyc',
  templateUrl: './kyc.component.html',
  styleUrl: './kyc.component.scss'
})
export class KycComponent implements OnInit {

  kycUrl: string = '';
  kycForm: UntypedFormGroup;
  paymentStatusSubscription: Subscription;
  window: Window | null = null;
  UpdateStatus = false;
  windowURL: string;
  constructor(private formBuilder: UntypedFormBuilder, private monedoService: MonedoService, private sanitizer: DomSanitizer, private router: Router, private spinner: NgxSpinnerService) {
    this.kycForm = formBuilder.group({
      aadhaarNumber: [
        '',
        [Validators.required, Validators.pattern('^[0-9]{12}$')],
      ]
    });
  }
  ngOnInit(): void {
    this.spinner.hide();
  }

  onSubmit() {
    this.UpdateStatus = false;
    if (this.kycForm.valid) {
      this.spinner.show();
      this.monedoService.InitiateKYC({ aadhaarNo: this.kycForm.value.aadhaarNumber, lat: 10, lon: 10 }).subscribe(response => {
        if (response['data'] != null) {
          this.kycUrl = response['data']['redirect_url'];
          this.spinner.hide();
          this.openPopup(this.kycUrl);
        }
        else {
          alert('Error initiating KYC. Please try again later.');
        }
      });
    }
  }

  get m() {
    return this.kycForm.controls;
  }

  /** Overlay Handle */
  public openPopup(url: string): void {
    this.startPaymentStatusCheck();
    document.getElementById('popup-kyc')!.style.display = 'block';
    document.getElementById('overlay-kyc')!.style.display = 'block';
    this.openWindow(url);
  }


  public startPaymentStatusCheck(): void {
    if (this.paymentStatusSubscription) {
      this.paymentStatusSubscription.unsubscribe();
    }

    this.paymentStatusSubscription = interval(10000).subscribe(async () => {
      const response = await this.monedoService.CheckKYCStatus({ bookingId: MemoryStorageService.getItem('bookingId') }).subscribe(response => {
        if (response['data']) {
          const result = response['data'];
          if (result.hasOwnProperty('response_msg') && result.response_msg === 'success') {

            if (this.paymentStatusSubscription) {
              this.paymentStatusSubscription.unsubscribe();
            }

            this.CloseWindow();

            if (this.UpdateStatus) {
              return;
            }

            this.UpdateStatus = true;

            return this.router.navigateByUrl('/assist-journey/m/consent');
          }
        }
      });
    });
  }

  public async openWindow(url: string) {

    this.windowURL = url;
    this.window = window.open(url, '_blank');

    await this.waitForWindowToClose();

    try {
      const response = this.monedoService.CheckKYCStatus({ bookingId: MemoryStorageService.getItem('bookingId') }).subscribe(response => {
        if (response['data']) {
          const result = response['data'];
          if (result.hasOwnProperty('response_msg') && result.response_msg === 'success') {

            if (this.UpdateStatus) {
              return;
            }

            if (this.paymentStatusSubscription) {
              this.paymentStatusSubscription.unsubscribe();
            }

            this.UpdateStatus = true;

            return this.router.navigateByUrl('/assist-journey/m/consent');
          }
          else {

            if (this.paymentStatusSubscription) {
              this.paymentStatusSubscription.unsubscribe();
            }

            return this.router.navigateByUrl('/assist-journey/m/consent');
          }
        }
      });
    } catch (error) {
      console.error('Error fetching NACH status:', error);
      alert("An error occurred while checking the Downpayment status.");
    }
  }

  public OpenWindowByUser() {
    if (!this.window || this.window.closed) {
      this.window = window.open(this.windowURL, '_blank');
    }
  }

  public CloseWindow() {
    if (this.window && !this.window.closed) {
      this.window.close();
    }
  }

  private waitForWindowToClose(): Promise<void> {
    return new Promise((resolve) => {
      const intervalId = window.setInterval(() => {
        if (this.window?.closed) {
          clearInterval(intervalId);
          document.getElementById('popup-kyc')!.style.display = 'none';
          document.getElementById('overlay-kyc')!.style.display = 'none';
          resolve();
        }
      }, 1000);
    });
  }

  /** -------------- **/
}
